import { MatchingOffer } from './../../model/matching-offer.model';
import { OfferService } from './../../service/offer.service';
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationRequestComponent } from '../../../shared/modal/confirmation-request/confirmation-request.component';
import { AccountService } from '../../service/account.service';
import { GoogleAnalysticsService } from 'src/app/shared/service/google-analystics.service';
import { ActionLogForOffer } from '../../model/action-log-for-offer.model';
import { Offer } from '../../../shared/model/offer.model';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-matching-button',
  templateUrl: './matching-button.component.html',
  styleUrls: ['./matching-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MatchingButtonComponent implements OnInit, OnDestroy {
  @Input() offerId: string;
  @Input() side: string;
  @Input() matchingOffer: MatchingOffer;
  @Input() orderFinished: string;
  @Input() projectAIMailId: string;
  @Input() workerAIMailId: string;
  @Input() actionLogForOffer: ActionLogForOffer;

  @Output()
  changeStatus: EventEmitter<any> = new EventEmitter();

  private subscriptions: Subscription = new Subscription();

  constructor(
    private modalService: NgbModal,
    private offerService: OfferService,
    private accountService: AccountService,
    private googleAnalysticsService: GoogleAnalysticsService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  // ステータス変更アクション(成立、不成立、リセット、削除)
  openChangeStatus(buttonType: string) {
    const params: Offer = {
      offer_id: this.offerId
    };
    let offer$;
    switch (buttonType) {
      case 'reset':
        offer$ = this.offerService.resetOffer(params);
        break;
      case 'failed':
        offer$ = this.offerService.failedOffer(params);
        // update action log
        this.actionLogForOffer.contract_established_user_id = this.accountService.getEmail();
        this.actionLogForOffer.contract_established = false;
        this.actionLogForOffer.contract_established_time = new Date();
        break;
      case 'succeeded':
        offer$ = this.offerService.succeededOffer(params);
        // update action log
        this.actionLogForOffer.contract_established_user_id = this.accountService.getEmail();
        this.actionLogForOffer.contract_established = true;
        this.actionLogForOffer.contract_established_time = new Date();
        break;
      case 'delete':
        offer$ = this.offerService.deleteOffer(params);
        break;
      case 'cancel':
        offer$ = this.offerService.cancelOffer(params);
        // update action log
        this.actionLogForOffer.cancel_user_id = this.accountService.getEmail();
        this.actionLogForOffer.cancel_time = new Date();
        break;
    }
    const offerSub = offer$.subscribe(res => {
      this.toastrService.success('オファーステータスが変更されました');
      const result = res.body.matching_offer;
      const status = result.progress_status;
      let GAevent: string;
      if (status === 'succeeded') {
        GAevent = '成立';
      } else if (status === 'failed') {
        GAevent = '不成立';
      } else if (status === 'considering') {
        // ステータスのリセットボタンが押された時，既にカウントされているので，ここでカウントしない
      }
      if (GAevent) {
        this.sendGAevent(GAevent);
      }

      this.changeStatus.emit(result);
    });
    this.subscriptions.add(offerSub);
  }

  // BP確認メールのモーダルを開く
  openConfirmModal(offerType: string) {
    const modalRef = this.modalService.open(ConfirmationRequestComponent, {
      windowClass: 'custom-modal'
    });

    modalRef.componentInstance.offerId = this.offerId;
    modalRef.componentInstance.offerType = offerType;
    modalRef.componentInstance.matchingOffer = this.matchingOffer;
    modalRef.componentInstance.projectAIMailId = this.projectAIMailId;
    modalRef.componentInstance.workerAIMailId = this.workerAIMailId;

    const modalResultSub = modalRef.result.then(result => {
      this.changeStatus.emit(result);
      // update action log
      if (offerType === 'project') {
        this.actionLogForOffer.project_confirm_user_id = this.accountService.getEmail();
        this.actionLogForOffer.project_confirm_from_offer_time = new Date();
      } else if (offerType === 'worker') {
        this.actionLogForOffer.worker_confirm_user_id = this.accountService.getEmail();
        this.actionLogForOffer.worker_confirm_from_offer_time = new Date();
      }
    });
    modalResultSub.then(() => {
      this.subscriptions.add(() => modalResultSub);
    });
  }

  // 承諾ボタンはモーダルで確認せずに実行
  acceptOffer(mailType: string): void {
    let offer$;
    if (mailType === 'worker') {
      offer$ = this.offerService.acceptedOfferWorker(this.OfferParams());
    } else if (mailType === 'project') {
      offer$ = this.offerService.acceptedOfferProject(this.OfferParams());
    }
    this.subscibeOfferService(offer$, mailType);
  }

  // 辞退ボタンはモーダルで確認せずに実行
  rejectOffer(mailType: string): void {
    let offer$;
    if (mailType === 'worker') {
      offer$ = this.offerService.rejectOfferWorker(this.OfferParams());
    } else if (mailType === 'project') {
      offer$ = this.offerService.rejectOfferProject(this.OfferParams());
    }
    this.subscibeOfferService(offer$, mailType);
  }

  OfferParams() {
    return {
      offer_id: this.offerId
    };
  }

  subscibeOfferService(offerService, mailType: string = 'null') {
    const offerServiceSub = offerService.subscribe(res => {
      // GA通知
      const offer = res.body.matching_offer;
      let GAevent: string;

      if (offer.progress_status === 'failed') {
        GAevent = mailType === 'project' ? '案件辞退' : '人材辞退';
        // 辞退の時は、オファーステータスが実質「不成立」なので、
        // contract_established（成立状態）と
        // contract_established_user_id（成立状態を決めたユーザーID）を変更
        this.actionLogForOffer.contract_established_user_id = this.accountService.getEmail();
        this.actionLogForOffer.contract_established = false;
      } else {
        if (offer.progress_status === 'interviewing') {
          this.sendGAevent('面談中');
        }
        GAevent = this.isProjectSide() ? '案件承諾' : '人材承諾';
      }
      this.sendGAevent(GAevent);

      this.changeStatus.emit(offer);

      // 案件・人材ごとに承諾・辞退のアクションログ表示を更新
      if (mailType === 'worker') {
        this.actionLogForOffer.worker_approve_user_id = this.accountService.getEmail();
        this.actionLogForOffer.worker_approve_time = new Date();
      } else if (mailType === 'project') {
        this.actionLogForOffer.project_approve_user_id = this.accountService.getEmail();
        this.actionLogForOffer.project_approve_time = new Date();
      }
    });
    this.subscriptions.add(offerServiceSub);
  }

  sendGAevent(GAevent: string): void {
    this.googleAnalysticsService.eventEmit(
      GAevent,
      this.projectAIMailId,
      this.workerAIMailId,
      0
    );
  }

  isSendMailWorker(): boolean {
    return this.matchingOffer.send_mail_worker;
  }
  isSendMailProject(): boolean {
    return this.matchingOffer.send_mail_project;
  }
  // ------------------------------
  // オファーサイド確認
  isProjectSide(): boolean {
    return this.side === 'project';
  }
  isWorkerSide(): boolean {
    return this.side === 'worker';
  }
  // ------------------------------
  // 検討中
  isConsidering(): boolean {
    return this.matchingOffer.progress_status === 'considering';
  }

  // 人材問合せ待ち
  isWaitingQueryWorker(): boolean {
    return this.matchingOffer.progress_status === 'waiting_query_worker';
  }

  // 人材確認待ち
  isCheckingWorker(): boolean {
    return this.matchingOffer.progress_status === 'checking_worker';
  }

  // 案件問合せ待ち
  isSecuredWorker(): boolean {
    return this.matchingOffer.progress_status === 'secured_worker';
  }

  // 案件確認待ち
  isCheckingProject(): boolean {
    return this.matchingOffer.progress_status === 'checking_project';
  }

  // 面談中
  isInterviewing(): boolean {
    return this.matchingOffer.progress_status === 'interviewing';
  }

  // 成立
  isSucceeded(): boolean {
    return this.matchingOffer.progress_status === 'succeeded';
  }

  // 不成立
  isFailed(): boolean {
    return this.matchingOffer.progress_status === 'failed';
  }

  // 人材NG
  isWorkerNg(): boolean {
    return this.matchingOffer.progress_status === 'worker_ng';
  }

  // 案件NG
  isProjectNg(): boolean {
    return this.matchingOffer.progress_status === 'project_ng';
  }

  // キャンセル
  isCancelled(): boolean {
    return this.matchingOffer.progress_status === 'cancelled';
  }

  // 募集終了
  isOrderFinished(): boolean {
    return !!this.orderFinished;
  }

  // ステータス変更不能
  isUnchangeable(): boolean {
    return this.isSucceeded() || this.isFailed() || this.isCancelled();
  }
}
